import { Component, Input } from '@angular/core';
import { Contract } from 'src/app/models/contract.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-contract]',
  template: `
    <td class="align-middle">{{contract?.id}}</td>
    <td class="align-middle">{{contract?.document_original_url}}</td>
    <td class="align-middle">{{contract?.settlement?.name}}</td>
    <td class="align-middle text-center">{{contract?.unit?.name}}</td>
    <td>{{contract?.contract_type?.name}}</td>
    <td class="align-middle text-center">{{contract?.sign_date | date: 'dd/MM/yyyy'}}</td>
    <td><a routerLink="{{contract?.id}}"><fa-icon [icon]="icons.faEdit"></fa-icon></a></td>
  `,
  styles: ``
})
export class TrContractComponent {
  @Input() contract: Contract | null = null;

  constructor(
    public icons: IconsService,
    public authService: AuthService,
  ) {     
  }

}
